import { Slot } from "./seatLayout";

export interface DisplaySlot {
	id: Slot;
	isOriginHole: boolean;
}

export function resolveDisplaySlot(slots: Slot[], index: number, activeId: number | null): DisplaySlot {
	if (activeId === null) {
		return { id: slots[index], isOriginHole: false };
	}
	if (index === activeId) {
		return { id: null, isOriginHole: true };
	}
	return { id: slots[index], isOriginHole: false };
}

export const GHOST_SEAT_PREFIX = "seat-ghost-";
export const SEAT_DND_PREFIX = "seat-";

export function seatDndId(index: number): string {
	return `${SEAT_DND_PREFIX}${index}`;
}

export function ghostSeatDndId(column: number): string {
	return `${GHOST_SEAT_PREFIX}${column}`;
}

/** Real slot index, or `slotCount + column` for a ghost cell below the last row. */
export function seatIndexFromDndId(id: string | number, slotCount: number): number {
	const raw = typeof id === "string" ? id : String(id);
	if (raw.startsWith(GHOST_SEAT_PREFIX)) {
		const col = Number(raw.slice(GHOST_SEAT_PREFIX.length));
		return slotCount + (Number.isFinite(col) ? col : 0);
	}
	const n = Number(raw.replace(/^seat-/, ""));
	return Number.isFinite(n) ? n : -1;
}

/** Indigo used for the "Move here" drop target (beta spec). */
export const MOVE_HERE_INDIGO = "#4F46E5";
